import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { Location } from '../../_models/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-driver-nav-bar',
  templateUrl: './driver-nav-bar.component.html',
  styleUrls: ['./driver-nav-bar.component.scss']
})
export class DriverNavBarComponent implements OnInit {
  currentUser: string = '';
  selectedLanguage: string = 'en';

  locations: Location[] = [];
  currentLocation: Location;
  languageList: LanguageList = new LanguageList();

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private authService: AuthService) { }

  ngOnInit() {
    this.setLanguageList(new LanguageList()); // Desde aca se puede cargar la lista de language desde algun servicio. Por ahora esta mockeado
    this.changeLanguage(this.languageList.lang.find(x => x.viewValue == "English").value); // Predeterminado al inicio, inglés.
  }

  ngOnChanges(){
  }

  userClick(e) {
    e.preventDefault();
  }

  logout(e) {
    e.preventDefault();
    this.authService.logoutProv();
  }

  changeLanguage(lang){
    this.translateService.use(lang);
  }

  setLanguageList(list){
    this.languageList = list;
  }

  onChangeLanguage(){
    this.changeLanguage(this.selectedLanguage);
  }

}

export class LanguageList {
  lang = [
    {value: 'en', viewValue: 'English'},
    {value: 'es', viewValue: 'Español'},
  ];
}
